// @flow
import { error } from './common';

import * as types from '../types/changeStopRequest';
import type {
  CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED_TYPE,
  CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS_TYPE,
  CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER_TYPE,
  CHANGE_STOP_REQUEST_CREATE_STARTED_TYPE,
  CHANGE_STOP_REQUEST_FETCH_FINISHED_TYPE,
  CHANGE_STOP_REQUEST_FETCH_STARTED_TYPE,
  CHANGE_STOP_REQUEST_TYPE,
  FETCH_CHANGE_STOP_REQUEST_COUNTER_TYPE,
  FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED_TYPE,
} from '../types/changeStopRequest';


export const startFetchChangeStopRequest = (
  schoolId: number,
  filters: {
    state: string,
    user: string,
    page?: number,
    page_size?: number,
    route_name: string,
    stop_name: string
  },
): CHANGE_STOP_REQUEST_FETCH_STARTED_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_FETCH_STARTED,
  payload: {
    schoolId,
    filters,
  },
});

export const fetchChangeStopRequestSucceed = (
  entities: Array<CHANGE_STOP_REQUEST_TYPE>,
  order: Array<number>,
  next?: number,
): CHANGE_STOP_REQUEST_FETCH_FINISHED_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_FETCH_FINISHED,
  payload: {
    entities,
    order,
    next,
  },
});

export const updateStateChangeStopRequestStarted = (
  changeStopRequestId: number,
  instance_type: string,
  state: string,
  description: string,
): CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED,
  payload: {
    changeStopRequestId,
    instance_type,
    state,
    description,
  },
});

export const changeStopRequestCreateStarted = (
  changeStopRequest: CHANGE_STOP_REQUEST_TYPE,
): CHANGE_STOP_REQUEST_CREATE_STARTED_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_CREATE_STARTED,
  payload: changeStopRequest,
});

export const changeStopRequestCreateSuccess = (
  changeStopRequest: CHANGE_STOP_REQUEST_TYPE,
): CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS,
  payload: changeStopRequest,
});

export const changeStopRequestCreateFailed = error(
  types.CHANGE_STOP_REQUEST_CREATE_FAILED,
);

export const updateStateChangeStopRequestSuccess = (
  changeStopRequest: CHANGE_STOP_REQUEST_TYPE,
): CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS,
  payload: changeStopRequest,
});

export const changeFilterChangeStopRequests = (
  stateType: string,
): CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER_TYPE => ({
  type: types.CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER,
  payload: stateType,
});

export const updateStateChangeStopRequestFailed = error(
  types.CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED,
);

export const fetchChangeStopRequestFailed = error(types.CHANGE_STOP_REQUEST_FETCH_FAILED);

export const fetchChangeStopCounter = (): FETCH_CHANGE_STOP_REQUEST_COUNTER_TYPE => ({
  type: types.FETCH_CHANGE_STOP_REQUEST_COUNTER,
});

export const successFetchChangeStopCounter = (
  counter: number
): FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED_TYPE => ({
  type: types.FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED,
  payload: counter,
});



// WEBPACK FOOTER //
// ./src/scripts/actions/changeStopRequests.js